import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { PsychometricEvaluationResponse } from '../models/response/psychometric-evaluation-response';
import { Paging } from '../models/page';
import { ResponseModel } from '../models/response-model';

@Injectable({
  providedIn: 'root'
})
export class PsychometricEvaluationService {
  private url = `${environment.url}/psychometricEvaluation`;
  constructor(private http: HttpClient) { }

  readEvaluationStatus(customerCode: string) {
    return this.http.get<ResponseModel<PsychometricEvaluationResponse>>(`${this.url}/${customerCode}/status`);
  }

  readToken(customerCode: string) {
    return this.http.get<ResponseModel<string>>(`${this.url}/${customerCode}/token`);
  }

  generateQrCodeImageBase64(textToConvert:string){
    let params = new HttpParams();
    params = params.set('textToConvert',textToConvert);
    return this.http.get<ResponseModel<string>>(`${this.url}/generateQrCode`,{params});
  }
}
